import { H as o } from "./styled-components.browser.esm-CdvvWRMU.js";
function i(e, t) {
  return {
    role: "button",
    tabIndex: t || 0,
    onClick: e
  };
}
o.pre`
  display: block;
  font-size: ${(e) => e.theme.fontSizeQuarck};
  width: 50%;
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDark};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  background-color: ${(e) => e.theme.colorNeutralDarkest};
  color: ${(e) => e.theme.colorNeutralLightest};
  margin-top: ${(e) => e.theme.spacingInsetSmRem};
`;
o.pre`
  display: block;
  font-size: ${(e) => e.theme.fontSizeQuarck};
  width: 100%;
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorNeutralDark};
  padding: ${(e) => e.theme.spacingInsetSmRem};
  background-color: ${(e) => e.theme.colorNeutralDarkest};
  color: ${(e) => e.theme.colorNeutralLightest};
  margin-top: ${(e) => e.theme.spacingInsetSmRem};
`;
const n = (e, t = 2) => {
  const r = e.toFixed(t).split(".");
  return r[0] = r[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), r.join(".");
};
export {
  i as a,
  n as f
};
